import React from 'react';
import { POSCatalogModelData } from '../../../../../common/libraries/modelViewer/Data/POSCatalogData';
import { useAppSelector } from '../../../../../Redux/Store/hooks';
import { FilePaths } from '../../../../../common/libraries/fileSystem/filePaths';

// Define the props interface for the component
interface CartItemThumbnailProps {
  catalogObject: POSCatalogModelData;
  articleVariant: string;
}

export function CartItemThumbnail({
  catalogObject,
  articleVariant,
} : CartItemThumbnailProps) : JSX.Element {

  // From the store, get the environment settings
  const environmentSettings = useAppSelector((state) => {
    return state.EnvironmentSettingsReducer;
  });

  // Check we this is an predefined variant
  if (catalogObject === undefined
    || catalogObject.data === undefined
    || catalogObject.data.variants === undefined
    || catalogObject.catalogData === undefined
  ) {
    return <div className="empty" />;
  }

  const customVariant = articleVariant === '';
  let variantImagePath;

  let applyBwCssEffect = false;

  if (customVariant) {
    // We don't have a defined image because the this is a customized variant

    if (catalogObject.hasVariants()) {
      // If there are other variants, use the image from the first variant, but
      // with CSS effects applied to it
      const firstVariant = catalogObject.data.variants[0];
      variantImagePath = firstVariant.imageRef;

      applyBwCssEffect = true;
    } else {
      variantImagePath = `${catalogObject.catalogData.name}.jpg`;
    }
  } else {
    // Grab the image from the variant
    const variant = catalogObject.getVariantByName(
      articleVariant,
    );

    if (variant) {
      variantImagePath = variant.imageRef;
    }
  }

  let imageClass = 'orderObjectImage';
  if (applyBwCssEffect) {
    imageClass += ' orderObjectImageMasked';
  }

  const imageAvailableToShow = variantImagePath !== undefined;

  const imagePath = FilePaths.join(
    environmentSettings.catalogInfoPath,
    FilePaths.join(
      catalogObject.getResourcesPath(),
      variantImagePath || '',
    ),
  );

  let catalogObjectName = '';
  if (catalogObject.catalogData) {
    catalogObjectName = catalogObject.catalogData.name;
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div className="orderObjectImageHolder">
        {imageAvailableToShow && (
        <img
          className={imageClass}
          src={imagePath}
          alt={`Catalog Object ${catalogObjectName}`}
        />
        )}
      </div>
    </div>
  );
}

export default CartItemThumbnail;
